export const scrubAnonymousProperties = () => {
  return {
    viralSourcePortalId: '',
    viralSourceUserId: '',
    referrerUrl: '',
    referrerParams: '',
    email: '',
    currentPageUrl: '',
    lastPageUrl: ''
  };
};